import { FunctionComponent } from "react";
import { Link } from "react-router-dom";
import { ReactComponent as RightArrow } from '../../../../../assets/landing-arrow-right.svg';
import { ecosystemData } from "../data";


const EcosystemSection: FunctionComponent = () => (
  <div className="flex flex-col lg:flex-row-reverse justify-between mt-14">
    <EcosystemImage />
    <EcosystemContent />
  </div>
);


const EcosystemImage: FunctionComponent = () => (
  <div className="lg:w-[45%]">
    <img
      src={ecosystemData.imageSrc}
      className="sm:w-full sm:h-[625px] lg:h-[720px] lg:w-[610px]"
      alt={ecosystemData.imageAlt}
    />
  </div>
);


const EcosystemContent: FunctionComponent = () => (
  <div className="lg:w-[45%] sm:mt-8 lg:mt-0">
    <EcosystemTitle />
    <EcosystemSubtitle />
    <EcosystemFeatures />
    <EcosystemCallToAction />
  </div>
);


const EcosystemTitle: FunctionComponent = () => (
  <h3 className="text-xl md:text-6xl text-center lg:text-left lg:text-4xl tracking-wider font-sans font-semibold lg:border-b-2 lg:border-secondary w-fit pr-2 pb-2 pl-12 sm:my-4 lg:mb-8 lg:mt-0">
    {ecosystemData.title}
  </h3>
);


const EcosystemSubtitle: FunctionComponent = () => (
  <h4 className="text-primary text-xl font-medium pl-12 mb-4">
    {ecosystemData.subtitle}
  </h4>
);


const EcosystemFeatures: FunctionComponent = () => (
  <div>
    {ecosystemData.features.map((feature, index) => (
      <EcosystemFeature key={index} title={feature.title} description={feature.description} />
    ))}
  </div>
);


const EcosystemFeature: FunctionComponent<{ title: string; description: string }> = ({ title, description }) => (
  <div className="mb-4">
    <p className="pr-20 mb-2 font-bold">
      {title}
    </p>
    <ul className="pl-6 list-disc">
      <li>{description}</li>
    </ul>
  </div>
);


const EcosystemCallToAction: FunctionComponent = () => (
  <Link to={ecosystemData.linkUrl} className="flex items-center mt-8">
    <p className="text-secondary">
      {ecosystemData.linkText}
    </p>
    <RightArrow height={20} width={30} className="mt-0.5 ml-4" />
  </Link>
);


export default EcosystemSection;


